import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { ButtonGroup, Theme, styled } from '@material-ui/core';
import {
  Button,
  Icons,
  FormControl,
  TextFieldAdapter,
  validations,
} from '../../../../shared/components';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';

type Props = {
  handleSubmit: (event: any) => void;
};

const StyledForm = styled('form')<Theme>(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

const StyledButtonGroup = styled(ButtonGroup)<Theme>(({ theme }) => ({
  display: 'block',
  paddingTop: theme.spacing(4),
}));

const AddSeriesFormContent: FC<Props> = ({ handleSubmit }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <StyledForm onSubmit={handleSubmit}>
        <FormControl label={t('shared.forms.title')} id="title" required>
          <Field name="title" component={TextFieldAdapter} validate={validations(t).required} />
        </FormControl>
        <StyledButtonGroup>
          <Button type="submit" icon={Icons.ADD_EXERCISES} style={{ padding: theme.spacing(2) }}>
            {t('trajectory.sections.shared.addSeriesBtn')}
          </Button>
        </StyledButtonGroup>
      </StyledForm>
    </>
  );
};

export default AddSeriesFormContent;
